module.exports = __webpack_public_path__ + "./welfare-sprouters-day_836dd7442376d8ad4cb80195395888e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/welfare-sprouters-day.jpg
// module id = 629
// module chunks = 0